import { Zap, Mail, Clock, GitBranch, Target, Plus } from "lucide-react";
import { STEP_TYPES } from "./automation.data";

const STEP_ICON = {
  trigger: Zap,
  email: Mail,
  wait: Clock,
  condition: GitBranch,
  goal: Target,
};

/**
 * AutomationFlow — vertical node graph of a journey's steps with connectors.
 * `editable` shows "add step" affordances between nodes (visual only).
 */
export default function AutomationFlow({ steps = [], editable = false }) {
  return (
    <div className="relative">
      {steps.map((s, i) => {
        const cfg = STEP_TYPES[s.type] ?? STEP_TYPES.email;
        const Icon = STEP_ICON[s.type] ?? Mail;
        const last = i === steps.length - 1;
        return (
          <div key={i} className="relative pl-14 pb-3 last:pb-0">
            {/* Connector line */}
            {!last && (
              <span
                className="absolute left-[19px] top-10 bottom-0 w-px"
                style={{ background: "var(--color-border-strong)" }}
              />
            )}

            {/* Node icon */}
            <div
              className="absolute left-0 top-0 w-10 h-10 rounded-xl flex items-center justify-center border"
              style={{ background: cfg.bg, borderColor: "var(--color-border)" }}
            >
              <Icon className="w-[18px] h-[18px]" style={{ color: cfg.color }} />
            </div>

            {/* Node card */}
            <div className="rounded-xl border border-border bg-surface px-4 py-2.5">
              <div className="flex items-center justify-between gap-2">
                <span className="text-sm font-semibold text-text_primary leading-tight">{s.label}</span>
                <span
                  className="text-[10px] font-bold uppercase tracking-wide px-1.5 py-0.5 rounded-full flex-shrink-0"
                  style={{ background: cfg.bg, color: cfg.color }}
                >
                  {cfg.label}
                </span>
              </div>
              {s.detail && <p className="text-xs text-text_muted mt-0.5">{s.detail}</p>}
            </div>

            {/* Add-step affordance */}
            {editable && !last && (
              <button
                className="absolute left-[11px] top-[52px] w-4 h-4 rounded-full flex items-center justify-center z-10 border border-border bg-surface text-text_muted hover:text-primary hover:border-primary transition-colors"
                title="Add step"
              >
                <Plus className="w-3 h-3" />
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
}
